// extracted by css-extract-rspack-plugin
export default {"modalBody":"modalBody-PyPElD"};